import { IconVolume } from "@/components/ui/icons";
import { Slider } from "@/components/ui/Slider";
import { usePlayer } from "@/hooks/usePlayer";

export function VolumeControl() {
  const { volume, setVolume } = usePlayer();
  return (
    <div className="row" style={{ gap: 6, alignItems: "center" }}>
      <IconVolume />
      <Slider value={volume} max={1} step={0.01} onChange={setVolume} width={110} ariaLabel="volume" />
    </div>
  );
}
